import { getMParticle } from 'tracking/utils/getMParticle';
import { getMParticleLocalStorage } from 'tracking/utils/getMParticleLocalStorage';

export const MPARTICLE_SESSION_ID_KEY = 'sid';

export const getMParticleSessionId = () => {
  const mParticle = getMParticle();
  let sessionId = null;

  if (mParticle?.sessionManager?.getSession) {
    sessionId = mParticle.sessionManager.getSession();
  } else {
    sessionId = getMParticleLocalStorage(MPARTICLE_SESSION_ID_KEY);
  }

  return sessionId;
};
